
import 'hammerjs'; 
import { BrowserModule , HammerModule} from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { AppRoutes } from './app.routing';
import { AppComponent } from './app.component';

import { FullComponent } from './layouts/full/full.component';
import { AppHeaderComponent } from './layouts/full/header/header.component';
import { AppSidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DemoMaterialModule } from './demo-material-module';

import { SharedModule } from './shared/shared.module';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { SpinnerService } from './components/spinner/spinner.service';

import { VersionModule } from './components/version/version.module';
import { PrimaryButtonModule } from './components/primary-button/primary-button.module';
import { SecondaryButtonModule } from './components/secondary-button/secondary-button.module';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import localeEs from "@angular/common/locales/es";

registerLocaleData(localeEs, "es");

@NgModule({
    declarations: [
        AppComponent,
        FullComponent,
        AppHeaderComponent,
        SpinnerComponent,
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
        {provide: MAT_DATE_LOCALE, useValue: "es"},
        {
            provide: LOCALE_ID,
            useValue: 'es-CL' // 'de-DE' for Germany, 'fr-FR' for France ...
        },
        SpinnerService
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        DemoMaterialModule,
        FormsModule,
        HttpClientModule,
        SharedModule,
        MatDialogModule,  
        MatProgressSpinnerModule, 
        RouterModule.forRoot(AppRoutes),
        AppSidebarComponent,
        VersionModule,
        PrimaryButtonModule,
        SecondaryButtonModule,
        NgxDocViewerModule,
        HammerModule
    ]
})
export class AppModule {}
